import { useTranslation } from 'next-i18next';
import React from 'react';

import { useGetWorkdaySummary } from '@/modules/workingDayReconciliation/apiHooks';
import CardContent from '@/modules/workingDayReconciliation/components/CrewLevel/DetailedCard/CardContent';
import WorkdaySupplierDetailsTable from '@/modules/workingDayReconciliation/components/CrewLevel/WorkdaySupplierDetailsTable';
import { Loading } from '@/shared/components/atoms';
import Collapse from '@/shared/components/atoms/Collapse';
import { useStore } from '@/shared/hooks/context/createGenericContext';

interface Props {
  date: string;
}

const DetailedCard: React.FC<Props> = ({ date }) => {
  const { t } = useTranslation('common');

  const [store] = useStore((store) => store);
  const isDemoFarm = store?.isDemoFarm;

  const { data: workdaySummary, isLoading } = useGetWorkdaySummary({
    date,
    entityId: store?.asset?.id,
  });

  // if loading
  if (isLoading) {
    return <Loading />;
  }

  // if no data found
  if (!workdaySummary && !isLoading) {
    return (
      <div className='w-full rounded-lg bg-white px-0 py-16 text-center text-20 font-semi-bold'>
        {t('no-jobs')}
      </div>
    );
  }

  return (
    <div className='flex flex-col gap-y-16 pb-16'>
      {workdaySummary?.map((summaryItem) => (
        <Collapse
          key={summaryItem?.supplierId}
          header={<CardContent data={summaryItem} />}
          childrenPadding='px-0 py-16'
          bgColor='bg-white'
          containerPadding='px-16'
          itemClassName={isDemoFarm ? 'cursor-default' : undefined}
          open={isDemoFarm ? false : undefined}
        >
          <WorkdaySupplierDetailsTable
            date={date}
            supplierId={summaryItem.supplierId}
          />
        </Collapse>
      ))}
    </div>
  );
};

export { DetailedCard };
